const addNotationValuesForChart = (data) => {
    return data.map((item) => {
        return [
            item,
            null,
            null,
        ]
    }).flat()
}

export default addNotationValuesForChart
